// footer.jsx
import React from 'react';
import './footer.css';
import logo from '../../images/f&S_Informática_Logo.png';

function Footer() {
  return (
    <div className="footer">
      <div>
      <div className='logo-container'>
        <img className='logo' src={logo} alt="logotipo da escola"/>
      </div>
      <div className='text-content'>      
      <p className='escola'>Colégio Fictício</p>
      <p className='endereco'>Endereço: Rua 99, nº 999, Av. Oliveira Paiva, Fortaleza-Ceará.</p>
      <p className='telefone'>(xx)xxxx-xxxx/(85)x.xxxx-xxxx</p>
      <p className='direitos'>© 2024 - Todos os direitos reservados</p>
      <p className='develop'>Desenvolvido por: <a href="https://www.linkedin.com/in/sergioabarbosa/">Sérgio Barbosa</a></p>
    </div>
    </div>
    </div>
  );
}

export default Footer;